import { MantineNumberSize, NavLink, useMantineTheme } from '@mantine/core';
import { FC, ReactNode } from 'react';

type Props = {
  opened?: boolean;
  defaultOpened?: boolean;
  active?: boolean;
  label?: ReactNode;
  icon?: ReactNode;
  childrenOffset?: MantineNumberSize;
  children?: ReactNode;
  onClick?: () => void;
  variant?: 'filled' | 'light' | 'subtle' | undefined;
  rightSection?: ReactNode;
  testId?: string;
  compact?: boolean;
};

const NavigationLink: FC<Props> = (props) => {
  const { colorScheme, colors } = useMantineTheme();
  const {
    opened,
    defaultOpened,
    active,
    label,
    icon,
    childrenOffset,
    children,
    onClick,
    variant,
    rightSection,
    testId,
    compact,
  } = props;
  const darkMode = colorScheme === 'dark';

  return (
    <NavLink
      defaultOpened={defaultOpened}
      opened={opened}
      active={active}
      label={label}
      icon={icon}
      childrenOffset={childrenOffset}
      color={darkMode ? undefined : 'lightBlue'}
      styles={{
        root: compact
          ? {
              paddingTop: 6,
              paddingBottom: 6,
              minHeight: 'unset',
            }
          : undefined,
        label: compact
          ? {
              lineHeight: 1.2,
            }
          : undefined,
        body: darkMode
          ? undefined
          : {
              color: active ? colors.blue[4] : '#282828',
              fontWeight: active ? 'bold' : 'normal',
            },
        icon: darkMode
          ? undefined
          : {
              color: active ? colors.blue[4] : '#282828',
            },
      }}
      onClick={onClick}
      variant={variant}
      rightSection={rightSection}
      data-testid={testId}
    >
      {children}
    </NavLink>
  );
};

export default NavigationLink;
